import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { LoaderService } from '../services/loader.service';

export const skipLoader: string = 'skipLoader=true';
const assetCheck: string = 'assets';

export const loaderInterceptor: HttpInterceptorFn = (req, next) => {
  const loaderService = inject(LoaderService);
  let newRequest = req;
  let requestLoaderShow = false;

  if (req.url.includes(assetCheck)) {
    return next(req);
  }
  if (req.url.includes(skipLoader) || req.url.startsWith(assetCheck)) {
    newRequest = req.clone({ url: req.url.replace(skipLoader, '') });
  } else {
    loaderService.show(newRequest.url);
    requestLoaderShow = true;
  }

  return next(newRequest).pipe(
    finalize(() => {
      if (requestLoaderShow) {
        loaderService.hide(req.url);
      }
    })
  );
};
